import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { ExportsService } from "./exports.service";
import { LoggerService } from "@teammood/shared/util/logger";
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { filter, Subject, takeUntil, tap } from "rxjs";

@Component({
    selector: 'exports',
    templateUrl: './exports.component.html',
    styleUrls: ['./exports.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportsComponent implements OnInit, OnDestroy {

    teamId: string;
    permission: string;

    private _destroy$ = new Subject<void>();

    constructor(
        private logger: LoggerService,
        private exportsService: ExportsService,
        private snackBarService: SnackBarService,
        private route: ActivatedRoute,
        private router: Router,
        ) {}
    
    ngOnInit() {

        this.route.params
            .pipe(
                filter(params => !!params['teamId']),
                tap(params => {
                    this.teamId = params['teamId'];
                }),
                takeUntil(this._destroy$)
            ).subscribe();

        this.permission = 'analyst'
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    async export (exportType: string, fileType: string) {
        try {
            const result = await this.exportsService.export(this.teamId, exportType, fileType)
            if (result.message) {
                this.snackBarService.success(result.message);
            }
        } catch (error) {
            this.logger.error("Exports error", error);
            this.snackBarService.error(error.data.error);
        }
    }
}
